<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Category</strong>
    </CCardHeader>
    <CCardBody>
      <CRow class="mt-3">
        <CCol sm="6">
          <CSelect
              label="Parent Category"
              :options="categories"
              :value.sync="category.parent"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInput
              label="Name"
              placeholder="Enter category name"
              v-model="category.name"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect
              label="Select Language"
              :options="languages"
              :value.sync="category.language"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <img :src="img_url" style="width: 200px; height: 200px" :alt="category.name"/>
          <CInputFile
              label="Image thumbnail"
              vertical
              ref="file"
              type="file"
              id="file"
              @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger"
          >(Image Size should be (360 X 360) and less than 1 MB)</label
          >
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInput
              label="Weight"
              placeholder="Enter Weight"
              v-model="category.weight"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"
      >
        <CIcon name="cil-check-circle"/>
        Update Category
      </CButton
      >
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "CategoryEdit",
  data() {
    return {
      category: {},
      img_url: "",
      categories: [{value: null, label: 'None'}],
      languages: [{value: 'en', label: 'English'}],
      selected_language: 'en'
    };
  },
  created() {
    this.getCategory();
    this.getCategories();
    this.getLanguages();
  },
  methods: {
    getLanguages() {
      this.$axios
          .get(`${ADMIN_URL}/languages`)
          .then((response) => {
            this.languages = response.data.languages
          })
          .catch((e) => {
            console.log("error occurs language", e);
          });
    },
    getCategory() {
      this.$axios
          .get(`${ADMIN_URL}/categories/${this.$route.params.id}`)
          .then((response) => {
            this.category = response.data.category;
            this.img_url = this.category.image_url;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    getCategories() {
      this.$axios
          .get(`${ADMIN_URL}/categories`)
          .then((response) => {
            let cats = response.data.category_list.filter((f) => {
              return f.parent === ""

            })
            cats.forEach((e) => {
              this.categories.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },

    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.category.image = file;
      this.img_url = URL.createObjectURL(file);
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("name", this.category.name);
      formData.append("parent", this.category.parent);
      formData.append("weight", this.category.weight);
      formData.append("image", this.category.image);
      formData.append("_method", "patch");
      formData.append("language", this.category.language);


      this.$axios
          .post(`${ADMIN_URL}/categories/${this.$route.params.id}`, formData, config)
          .then((response) => {
            currentObj.success = response.data.success;
            this.$swal("Success", response.data.message, "success");
            this.$router.go(0)
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal(
                "Error",
                JSON.stringify(error.response.data.message),
                "error"
            );
          });
    },
  },
};
</script>

<style scoped>
</style>
